import _implicitStylesheets from "./achievements.css";
import _implicitScopedStylesheets from "./achievements.scoped.css?scoped=true";
import _wdsMediaCard from "wds/mediaCard";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-6" class="section-heading${0}" data-scroll-to="achievements"${"a0:data-dummy"}${2}>${"t1"}</h3>`;
const stc0 = {
  classMap: {
    "card-grid": true
  },
  key: 2
};
const stc1 = {
  "card-grid__item": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, c: api_custom_element, h: api_element, i: api_iterator} = $api;
  return [$cmp.hasAchievements ? api_static_fragment($fragment1, 1, [api_static_part(0, {
    attrs: {
      "data-dummy": $cmp.scrollToParam
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.heading))]) : null, $cmp.hasAchievements ? api_element("div", stc0, api_iterator($cmp.achievementCards, function (card) {
    return api_element("div", {
      classMap: stc1,
      key: api_key(3, card.key)
    }, [api_custom_element("wds-media-card", _wdsMediaCard, {
      props: {
        "category": card.category,
        "title": card.title,
        "subtitle": card.subtitle,
        "image": card.image,
        "callToAction": card.callToAction,
        "ctaAriaLabel": card.ctaAriaLabel
      },
      key: 4
    })]);
  })) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-363ip1nubav";
tmpl.legacyStylesheetToken = "undefined-_achievements";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
